import React from 'react';
import { Route, Routes } from 'react-router-dom'
import Home from '../Pages/Home/Home'
import AboutUs from "../Pages/AboutUs/AboutUs"
import BoardOfDirectors from '../Pages/BoardOfDirectors';
import Developers from '../Pages/Developers/Developers';

const PageRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route path="/company/about-us" element={<AboutUs />} /> */}
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/company/board-of-directors" element={<BoardOfDirectors />} />
                <Route path="/company/developers" element={<Developers />} />

            </Routes>
        </>
    )
}

export default PageRoutes